/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as RejoinRouteImport } from './routes/rejoin'
import { Route as JoinRouteImport } from './routes/join'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SessionsIndexRouteImport } from './routes/sessions/index'
import { Route as GamesIndexRouteImport } from './routes/games/index'
import { Route as SessionsNewRouteImport } from './routes/sessions/new'
import { Route as SessionsIdRouteImport } from './routes/sessions/$id'
import { Route as RsvpTokenRouteImport } from './routes/rsvp.$token'
import { Route as JoinJoinCodeRouteImport } from './routes/join_.$joinCode'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as GamesIdRouteImport } from './routes/games/$id'
import { Route as SessionsIdTvRouteImport } from './routes/sessions/$id_.tv'
import { Route as SessionsIdGameRouteImport } from './routes/sessions/$id_.game'
import { Route as SessionsIdBuilderRouteImport } from './routes/sessions/$id_.builder'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const RejoinRoute = RejoinRouteImport.update({
  id: '/rejoin',
  path: '/rejoin',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsIndexRoute = SessionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SessionsRoute,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsNewRoute = SessionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SessionsRoute,
} as any)
const SessionsIdRoute = SessionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SessionsRoute,
} as any)
const RsvpTokenRoute = RsvpTokenRouteImport.update({
  id: '/rsvp/$token',
  path: '/rsvp/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinJoinCodeRoute = JoinJoinCodeRouteImport.update({
  id: '/join_/$joinCode',
  path: '/join/$joinCode',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdRoute = GamesIdRouteImport.update({
  id: '/games/$id',
  path: '/games/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsIdTvRoute = SessionsIdTvRouteImport.update({
  id: '/$id_/tv',
  path: '/$id/tv',
  getParentRoute: () => SessionsRoute,
} as any)
const SessionsIdGameRoute = SessionsIdGameRouteImport.update({
  id: '/$id_/game',
  path: '/$id/game',
  getParentRoute: () => SessionsRoute,
} as any)
const SessionsIdBuilderRoute = SessionsIdBuilderRouteImport.update({
  id: '/$id_/builder',
  path: '/$id/builder',
  getParentRoute: () => SessionsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/join': typeof JoinRoute
  '/rejoin': typeof RejoinRoute
  '/sessions': typeof SessionsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/games/$id': typeof GamesIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/join/$joinCode': typeof JoinJoinCodeRoute
  '/rsvp/$token': typeof RsvpTokenRoute
  '/sessions/$id': typeof SessionsIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/games': typeof GamesIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/sessions/$id/builder': typeof SessionsIdBuilderRoute
  '/sessions/$id/game': typeof SessionsIdGameRoute
  '/sessions/$id/tv': typeof SessionsIdTvRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/join': typeof JoinRoute
  '/rejoin': typeof RejoinRoute
  '/settings': typeof SettingsRoute
  '/games/$id': typeof GamesIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/join/$joinCode': typeof JoinJoinCodeRoute
  '/rsvp/$token': typeof RsvpTokenRoute
  '/sessions/$id': typeof SessionsIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/games': typeof GamesIndexRoute
  '/sessions': typeof SessionsIndexRoute
  '/sessions/$id/builder': typeof SessionsIdBuilderRoute
  '/sessions/$id/game': typeof SessionsIdGameRoute
  '/sessions/$id/tv': typeof SessionsIdTvRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/join': typeof JoinRoute
  '/rejoin': typeof RejoinRoute
  '/sessions': typeof SessionsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/games/$id': typeof GamesIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/join_/$joinCode': typeof JoinJoinCodeRoute
  '/rsvp/$token': typeof RsvpTokenRoute
  '/sessions/$id': typeof SessionsIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/games/': typeof GamesIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/sessions/$id_/builder': typeof SessionsIdBuilderRoute
  '/sessions/$id_/game': typeof SessionsIdGameRoute
  '/sessions/$id_/tv': typeof SessionsIdTvRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/history'
    | '/join'
    | '/rejoin'
    | '/sessions'
    | '/settings'
    | '/games/$id'
    | '/invite/$token'
    | '/join/$joinCode'
    | '/rsvp/$token'
    | '/sessions/$id'
    | '/sessions/new'
    | '/games'
    | '/sessions/'
    | '/sessions/$id/builder'
    | '/sessions/$id/game'
    | '/sessions/$id/tv'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/history'
    | '/join'
    | '/rejoin'
    | '/settings'
    | '/games/$id'
    | '/invite/$token'
    | '/join/$joinCode'
    | '/rsvp/$token'
    | '/sessions/$id'
    | '/sessions/new'
    | '/games'
    | '/sessions'
    | '/sessions/$id/builder'
    | '/sessions/$id/game'
    | '/sessions/$id/tv'
  id:
    | '__root__'
    | '/'
    | '/history'
    | '/join'
    | '/rejoin'
    | '/sessions'
    | '/settings'
    | '/games/$id'
    | '/invite/$token'
    | '/join_/$joinCode'
    | '/rsvp/$token'
    | '/sessions/$id'
    | '/sessions/new'
    | '/games/'
    | '/sessions/'
    | '/sessions/$id_/builder'
    | '/sessions/$id_/game'
    | '/sessions/$id_/tv'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoryRoute: typeof HistoryRoute
  JoinRoute: typeof JoinRoute
  RejoinRoute: typeof RejoinRoute
  SessionsRoute: typeof SessionsRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  GamesIdRoute: typeof GamesIdRoute
  InviteTokenRoute: typeof InviteTokenRoute
  JoinJoinCodeRoute: typeof JoinJoinCodeRoute
  RsvpTokenRoute: typeof RsvpTokenRoute
  GamesIndexRoute: typeof GamesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rejoin': {
      id: '/rejoin'
      path: '/rejoin'
      fullPath: '/rejoin'
      preLoaderRoute: typeof RejoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/': {
      id: '/sessions/'
      path: '/'
      fullPath: '/sessions/'
      preLoaderRoute: typeof SessionsIndexRouteImport
      parentRoute: typeof SessionsRoute
    }
    '/games/': {
      id: '/games/'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/new': {
      id: '/sessions/new'
      path: '/new'
      fullPath: '/sessions/new'
      preLoaderRoute: typeof SessionsNewRouteImport
      parentRoute: typeof SessionsRoute
    }
    '/sessions/$id': {
      id: '/sessions/$id'
      path: '/$id'
      fullPath: '/sessions/$id'
      preLoaderRoute: typeof SessionsIdRouteImport
      parentRoute: typeof SessionsRoute
    }
    '/rsvp/$token': {
      id: '/rsvp/$token'
      path: '/rsvp/$token'
      fullPath: '/rsvp/$token'
      preLoaderRoute: typeof RsvpTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join_/$joinCode': {
      id: '/join_/$joinCode'
      path: '/join/$joinCode'
      fullPath: '/join/$joinCode'
      preLoaderRoute: typeof JoinJoinCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id': {
      id: '/games/$id'
      path: '/games/$id'
      fullPath: '/games/$id'
      preLoaderRoute: typeof GamesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/$id_/tv': {
      id: '/sessions/$id_/tv'
      path: '/$id/tv'
      fullPath: '/sessions/$id/tv'
      preLoaderRoute: typeof SessionsIdTvRouteImport
      parentRoute: typeof SessionsRoute
    }
    '/sessions/$id_/game': {
      id: '/sessions/$id_/game'
      path: '/$id/game'
      fullPath: '/sessions/$id/game'
      preLoaderRoute: typeof SessionsIdGameRouteImport
      parentRoute: typeof SessionsRoute
    }
    '/sessions/$id_/builder': {
      id: '/sessions/$id_/builder'
      path: '/$id/builder'
      fullPath: '/sessions/$id/builder'
      preLoaderRoute: typeof SessionsIdBuilderRouteImport
      parentRoute: typeof SessionsRoute
    }
  }
}

interface SessionsRouteChildren {
  SessionsIdRoute: typeof SessionsIdRoute
  SessionsNewRoute: typeof SessionsNewRoute
  SessionsIndexRoute: typeof SessionsIndexRoute
  SessionsIdBuilderRoute: typeof SessionsIdBuilderRoute
  SessionsIdGameRoute: typeof SessionsIdGameRoute
  SessionsIdTvRoute: typeof SessionsIdTvRoute
}

const SessionsRouteChildren: SessionsRouteChildren = {
  SessionsIdRoute: SessionsIdRoute,
  SessionsNewRoute: SessionsNewRoute,
  SessionsIndexRoute: SessionsIndexRoute,
  SessionsIdBuilderRoute: SessionsIdBuilderRoute,
  SessionsIdGameRoute: SessionsIdGameRoute,
  SessionsIdTvRoute: SessionsIdTvRoute,
}

const SessionsRouteWithChildren = SessionsRoute._addFileChildren(
  SessionsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoryRoute: HistoryRoute,
  JoinRoute: JoinRoute,
  RejoinRoute: RejoinRoute,
  SessionsRoute: SessionsRouteWithChildren,
  SettingsRoute: SettingsRoute,
  GamesIdRoute: GamesIdRoute,
  InviteTokenRoute: InviteTokenRoute,
  JoinJoinCodeRoute: JoinJoinCodeRoute,
  RsvpTokenRoute: RsvpTokenRoute,
  GamesIndexRoute: GamesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
